export default {
  label: 'Select Field',
  key: 'select',
  placeholder: 'Select',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  hideLabel: false,
  disabled: false,
  multiple: false,
  dataSrc: 'values',
  reloadSourceURL: false,
  dataSrcDependentFields: [],
  defaultValue: {
    type: 'value',
    value: ''
  },
  data: {
    values: [
      {
        label: '',
        value: ''
      }
    ],
    url: ''
  },
  // searchEnabled: true,
  validate: {
    required: false
  },
  type: 'selectComponent',
  isNew: true,
  input: true,
  amsField: ''
};
